import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';

import {Observable} from 'rxjs/Observable';

/*
  Generated class for the ConsumerBondRedeemHandlerProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
@Injectable()
export class ConsumerBondRedeemHandlerProvider {
	observer: any;
	subscription: any;

	constructor(public http: Http) {
		this.subscription = Observable.create(observer => {
		  this.observer = observer;
		});
	}

	
}



// WEBPACK FOOTER //
// ./src/providers/consumer-bond-redeem-handler.ts